<template>
  <v-container>
    <v-row no-gutters class="mb-1">
      <SalesAdder></SalesAdder>
    </v-row>
    <v-card>
      <v-card-text>
        <SalesGrid :loading="loading"></SalesGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { SalesAdder, SalesGrid } from "../components";
export default {
  name: "SalesIndex",
  components: {
    SalesAdder,
    SalesGrid
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadSales");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
